"use strict";
/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeExchange = void 0;
class CodeExchange {
    constructor(authService) {
        this.authService = authService;
    }
    execute(request) {
        const { code } = request;
        return this.authService.codeExchange(code);
    }
}
exports.CodeExchange = CodeExchange;
